import { type FunctionComponentWithRef, useMemo } from "react";

import { Variant } from "./enums";
import { CenteredContainer, SpinnerIcon } from "./styles";
import { WheelIcon } from "./wheel-icon";

export type Props = {
  className?: string;
  variant?: Variant;
};

export const Loading: FunctionComponentWithRef<Props, HTMLDivElement> = ({
  className,
  ref,
  variant = Variant.Wheel,
}) => {
  const IconComponent = useMemo(() => {
    switch (variant) {
      case Variant.Spinner:
        return SpinnerIcon;
      case Variant.Wheel:
        return WheelIcon;
    }
  }, [variant]);

  return (
    <CenteredContainer className={className}>
      <div ref={ref}>
        <IconComponent />
      </div>
    </CenteredContainer>
  );
};

Loading.displayName = "Loading";
